class SortingSelector extends HTMLElement {
    connectedCallback() {
      this.headerButton = this.querySelector(".sorting-selector__header");
      this.options = this.querySelector(".sorting-selector__options");
  
      this.headerButton.addEventListener("click", (e) => this.toggleDropdown(e));
      document.addEventListener("click", (e) => this.handleClickOutside(e));
      this.addEventListener("click", (e) => this.handleOptionClick(e));
    }
  
    disconnectedCallback() {
      this.headerButton.removeEventListener("click", this.toggleDropdown);
      document.removeEventListener("click", this.handleClickOutside);
      this.removeEventListener("click", this.handleOptionClick);
    }
  
    toggleDropdown(event) {
      event.stopPropagation();
      const isOpen = !this.options.classList.contains("is-hidden");
      this.options.classList.toggle("is-hidden");
  
      this.headerButton.setAttribute("aria-expanded", isOpen ? "false" : "true");
    }
  
    handleOptionClick(event) {
      const option = event.target.closest(".sorting-selector__option");
      if (option) {
        this.clearSelectedOptions();
        option.classList.add("sorting-selector__option--selected");
        option.setAttribute("aria-selected", "true");
  
        const selectedValueHTML = option.querySelector(".sorting-selector__value").innerHTML;
        this.querySelector(".sorting-selector__header .sorting-selector__value").innerHTML = selectedValueHTML;
  
        this.options.classList.add("is-hidden");
      }
    }
  
    clearSelectedOptions() {
      const allOptions = this.querySelectorAll(".sorting-selector__option");
      allOptions.forEach((option) => {
        option.classList.remove("sorting-selector__option--selected");
        option.setAttribute("aria-selected", "false");
      });
    }
  
    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.options.classList.add("is-hidden");
      }
    }
  }
  
  if (!customElements.get("sorting-selector")) {
    customElements.define("sorting-selector", SortingSelector);
  }